// TODO: Split into modules

import type { SlateBlock } from '@atlas/renderer';
import { Editor } from 'slate';
import { ReactEditor } from 'slate-react';
import { type OneLineTextBlock, ONE_LINE_TEXT_BLOCK_TYPES } from '@atlas/tool/box/slate/isOneLineTextBlock';
import { type MultiLineTextBlock, MULTI_LINE_TEXT_BLOCK_TYPES } from '@atlas/tool/box/slate/isMultiLineTextBlock';
import { type ListBlock, LIST_BLOCKS_TYPES } from '@atlas/tool/box/slate/isListBlock';
import isBlockActive from '@atlas/tool/box/slate/isBlockActive';
import convertBlocksToOneLineTexts from '@atlas/tool/box/slate/convertBlocksToOneLineTexts';
import convertBlocksToLists from '@atlas/tool/box/slate/convertBlocksToLists';
import convertBlocksToMultiLineTexts from '@atlas/tool/box/slate/convertBlocksToMultiLineTexts';
import convertBlocksToCallouts from '@atlas/tool/box/slate/convertBlocksToCallouts';
import changeEditorSelection from '@atlas/tool/box/slate/changeEditorSelection';

export default function toggleBlock(editor: Editor, blockType: SlateBlock['type']) {
    if (!editor.selection) {
        const point = Editor.end(editor, []);
        changeEditorSelection(editor, { anchor: point, focus: point });
        queueMicrotask(() => ReactEditor.focus(editor));
    }

    if (blockType === 'callout') {
        return toggleCalloutBlock(editor);
    }

    if ((LIST_BLOCKS_TYPES as Array<SlateBlock['type']>).includes(blockType)) {
        return toggleList(editor, blockType as ListBlock['type']);
    }

    if ((MULTI_LINE_TEXT_BLOCK_TYPES as Array<SlateBlock['type']>).includes(blockType)) {
        return toggleMultiLineBlock(editor, blockType as MultiLineTextBlock['type']);
    }

    if ((ONE_LINE_TEXT_BLOCK_TYPES as Array<SlateBlock['type']>).includes(blockType)) {
        return toggleOneLineTextBlock(editor, blockType as OneLineTextBlock['type']);
    }
}

// #region Helpers

const toggleList = (editor: Editor, blockType: ListBlock['type']) => {
    if (!editor.selection) return;

    if (isBlockActive(editor, blockType)) {
        convertBlocksToOneLineTexts(editor, 'paragraph', { match: blockType });
    } else {
        convertBlocksToLists(editor, blockType);
    }
};

const toggleMultiLineBlock = (editor: Editor, blockType: MultiLineTextBlock['type']) => {
    if (!editor.selection) return;

    if (isBlockActive(editor, blockType)) {
        convertBlocksToOneLineTexts(editor, 'paragraph', { match: blockType });
    } else {
        convertBlocksToMultiLineTexts(editor, blockType);
    }
};

const toggleCalloutBlock = (editor: Editor) => {
    if (!editor.selection) return;

    if (isBlockActive(editor, 'callout')) {
        convertBlocksToOneLineTexts(editor, 'paragraph', { match: 'callout' });
    } else {
        convertBlocksToCallouts(editor);
    }
};

export const toggleOneLineTextBlock = (editor: Editor, blockType: OneLineTextBlock['type']) => {
    if (!editor.selection) return;

    if (isBlockActive(editor, blockType)) {
        if (blockType === 'paragraph') return;
        convertBlocksToOneLineTexts(editor, 'paragraph', { match: blockType });
    } else {
        convertBlocksToOneLineTexts(editor, blockType);
    }
};

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('toggleMark', () => {
        it.todo('🤷🏼');
    });
}

// #endregion
